import {
  FETCH_CALENDAR_EVENTS,
  SET_CALENDAR_EVENTS,
  FETCH_CALENDAR_FLOWS,
  SET_CALENDAR_FLOWS,
  PAUSE_SCHEDULE,
  RESUME_SCHEDULE,
  CREATE_SCHEDULE,
  CREATE_SCHEDULE_FROM_TRIGGER,
  UPDATE_SCHEDULE,
  SET_SAVE_SCHEDULE_SUCCESS,
  SET_SAVE_SCHEDULE_SUCCESS_RESET,
  SET_SAVE_SCHEDULE_FAILED,
  SET_SAVE_SCHEDULE_FAILED_RESET,
  DELETE_SCHEDULE,
  FETCH_CALENDAR_EVENTS_BY_FLOW_ID,
  UPDATE_SCHEDULE_FROM_TRIGGER,
  UPDATE_SCHEDULE_DOCUMENTATION,
  FETCH_SHARED_SCHEDULES,
  SET_SHARED_SCHEDULES
} from "redux/constants/flowDesigner";

export const fetchCalendarEvents = (tenant_id) => ({
  type: FETCH_CALENDAR_EVENTS,
  payload: { tenant_id }
});
export const fetchCalendarFlows = (tenant_id) => ({
  type: FETCH_CALENDAR_FLOWS,
  payload: { tenant_id }
});
export const setCalendarEvents = (payload) => ({
  type: SET_CALENDAR_EVENTS,
  payload
});
export const setCalendarFlows = (payload) => ({
  type: SET_CALENDAR_FLOWS,
  payload
});
export const pauseSchedule = (tenant_id, schedule_id) => ({
  type: PAUSE_SCHEDULE,
  payload: { tenant_id, schedule_id, status: "Paused" }
});
export const resumeSchedule = (tenant_id, schedule_id, status) => ({
  type: RESUME_SCHEDULE,
  payload: { tenant_id, schedule_id, status }
});
export const createSchedule = (tenant_id, input) => ({
  type: CREATE_SCHEDULE,
  payload: { tenant_id, input }
});
export const createScheduleFromTrigger = (tenant_id, input) => ({
  type: CREATE_SCHEDULE_FROM_TRIGGER,
  payload: { tenant_id, input }
});
export const updateScheduleFromTrigger = (tenant_id, schedule_id, input) => ({
  type: UPDATE_SCHEDULE_FROM_TRIGGER,
  payload: { tenant_id, schedule_id, input }
});
export const updateSchedule = (tenant_id, schedule_id, input) => ({
  type: UPDATE_SCHEDULE,
  payload: { tenant_id, schedule_id, input }
});
export const deleteSchedule = (tenant_id, schedule_id) => ({
  type: DELETE_SCHEDULE,
  payload: { tenant_id, schedule_id }
});
export const setSaveScheduleSuccess = () => ({
  type: SET_SAVE_SCHEDULE_SUCCESS
});
export const setSaveScheduleSuccessReset = () => ({
  type: SET_SAVE_SCHEDULE_SUCCESS_RESET
});
export const setSaveScheduleFailed = () => ({
  type: SET_SAVE_SCHEDULE_FAILED
});
export const setSaveScheduleFailedReset = () => ({
  type: SET_SAVE_SCHEDULE_FAILED_RESET
});
export const fetchCalendarEventsByFlowId = (tenant_id, flow_id) => ({
  type: FETCH_CALENDAR_EVENTS_BY_FLOW_ID,
  payload: { tenant_id, flow_id }
});
export const updateScheduleDocumentation = (tenant_id, id, documentation) => ({
  type: UPDATE_SCHEDULE_DOCUMENTATION,
  payload: { tenant_id, id, documentation }
});
export const fetchSharedSchedules = (tenant_id, user_id) => ({
  type: FETCH_SHARED_SCHEDULES,
  payload: { tenant_id, user_id }
});
export const setSharedSchedules = (payload) => ({
  type: SET_SHARED_SCHEDULES,
  payload
});
